import * as ActionType from '../../constants/actionType';
import {
  WellBottomProfile,
  WellSurfaceDataShape,
  WellCount,
  DefaultWellValue,
  PlateType,
} from '../../constants/dataEnum';
import {WellLabel} from '../../contents/PlateTypeEditor/PlateTypeEditorEnum';

const initialState = {
  id: null,
  lastProcessedId: null,
  currentWizardView: 1,
  allowedToNext: true,
  processedStep: 0,
  wellNumber: WellCount.WELL_96,
  wellLabel: WellLabel.WELL_96,
  wellBottomProfile: WellBottomProfile.ROUNDED,
  wellShape: WellSurfaceDataShape.CIRCLE,
  plateName: '',
  partNumber: '',
  vendor: '',
  notes: '',
  height: 0,
  depth: 0,
  width: 0,
  length: 0,
  columnOrigin: 0,
  rowOrigin: 0,
  columnPitch: DefaultWellValue.WELL_96.columnPitch,
  rowPitch: DefaultWellValue.WELL_96.rowPitch,
  capacity: 0,
  workingVolume: 0,
  plateType: PlateType.MICROPLATE,
  colPitchAssaySample: 0,
  troughDepth: 0,
  isEjectedTray: true,
  editMode: false,
};

function getPitchByWellLabel(wellLabel) {
  let columnPitch;
  let rowPitch;
  switch (wellLabel) {
    case WellLabel.WELL_1:
      columnPitch = DefaultWellValue.WELL_1.columnPitch;
      rowPitch = DefaultWellValue.WELL_1.rowPitch;
      break;
    case WellLabel.WELL_6:
      columnPitch = DefaultWellValue.WELL_6.columnPitch;
      rowPitch = DefaultWellValue.WELL_6.rowPitch;
      break;
    case WellLabel.WELL_8:
      columnPitch = DefaultWellValue.WELL_8.columnPitch;
      rowPitch = DefaultWellValue.WELL_8.rowPitch;
      break;
    case WellLabel.WELL_12:
      columnPitch = DefaultWellValue.WELL_12.columnPitch;
      rowPitch = DefaultWellValue.WELL_12.rowPitch;
      break;
    case WellLabel.WELL_24:
      columnPitch = DefaultWellValue.WELL_24.columnPitch;
      rowPitch = DefaultWellValue.WELL_24.rowPitch;
      break;
    case WellLabel.WELL_48:
      columnPitch = DefaultWellValue.WELL_48.columnPitch;
      rowPitch = DefaultWellValue.WELL_48.rowPitch;
      break;
    case WellLabel.WELL_96:
      columnPitch = DefaultWellValue.WELL_96.columnPitch;
      rowPitch = DefaultWellValue.WELL_96.rowPitch;
      break;
    case WellLabel.WELL_384:
      columnPitch = DefaultWellValue.WELL_384.columnPitch;
      rowPitch = DefaultWellValue.WELL_384.rowPitch;
      break;
    case WellLabel.WELL_IFC_192_24:
      columnPitch = DefaultWellValue.WELL_IFC_192_24.columnPitch;
      rowPitch = DefaultWellValue.WELL_IFC_192_24.rowPitch;
      break;
    case WellLabel.WELL_IFC_96_96:
      columnPitch = DefaultWellValue.WELL_IFC_96_96.columnPitch;
      rowPitch = DefaultWellValue.WELL_IFC_96_96.rowPitch;
      break;
    case WellLabel.WELL_IFC_48_48:
      columnPitch = DefaultWellValue.WELL_IFC_48_48.columnPitch;
      rowPitch = DefaultWellValue.WELL_IFC_48_48.rowPitch;
      break;
    default:
      break;
  }
  return [columnPitch, rowPitch];
}

export default function plateTypeEditorStateReducer(state = initialState, action = '') {
  switch (action.type) {
    case ActionType.PTE_SET_CURRENT_WIZARD_VIEW:
      return {...state, currentWizardView: action.currentWizardView};
    case ActionType.PTE_INCREMENT_CURRENT_WIZARD_VIEW:
      return {...state, currentWizardView: state.currentWizardView + 1};
    case ActionType.PTE_DECREMENT_CURRENT_WIZARD_VIEW: {
      return {...state, currentWizardView: state.currentWizardView - 1};
    }
    case ActionType.PTE_SET_ALLOWED_TO_NEXT:
      return {...state, allowedToNext: action.allowedToNext};
    case ActionType.PTE_SET_PROCESSED_STEP:
      return {...state, processedStep: action.processedStep};
    case ActionType.PTE_SET_WELL_NUMBER:
      return {...state, wellNumber: action.wellNumber};
    case ActionType.PTE_SET_WELL_LABEL: {
      const [columnPitch, rowPitch] = getPitchByWellLabel(action.wellLabel);
      return {...state, wellLabel: action.wellLabel, columnPitch, rowPitch};
    }
    case ActionType.PTE_SET_WELL_BOTTOM_PROFILE:
      return {...state, wellBottomProfile: action.wellBottomProfile};
    case ActionType.PTE_SET_WELL_SHAPE:
      return {...state, wellShape: action.wellShape};
    case ActionType.PTE_SET_PLATE_NAME:
      return {...state, plateName: action.plateName};
    case ActionType.PTE_SET_PLATE_TYPE:
      return {...state, plateType: action.plateType};
    case ActionType.PTE_SET_PART_NUMBER:
      return {...state, partNumber: action.partNumber};
    case ActionType.PTE_SET_VENDOR:
      return {...state, vendor: action.vendor};
    case ActionType.PTE_SET_NOTES:
      return {...state, notes: action.notes};
    case ActionType.PTE_SET_HEIGHT:
      return {...state, height: action.height};
    case ActionType.PTE_SET_DEPTH:
      return {...state, depth: action.depth};
    case ActionType.PTE_SET_WIDTH:
      return {...state, width: action.width};
    case ActionType.PTE_SET_LENGTH:
      return {...state, length: action.length};
    case ActionType.PTE_SET_COLUMN_ORIGIN:
      return {...state, columnOrigin: action.columnOrigin};
    case ActionType.PTE_SET_ROW_ORIGIN:
      return {...state, rowOrigin: action.rowOrigin};
    case ActionType.PTE_SET_COLUMN_PITCH:
      return {...state, columnPitch: action.columnPitch};
    case ActionType.PTE_SET_ROW_PITCH:
      return {...state, rowPitch: action.rowPitch};
    case ActionType.PTE_SET_CAPACITY:
      return {...state, capacity: action.capacity};
    case ActionType.PTE_SET_WORKING_VOLUME:
      return {...state, workingVolume: action.workingVolume};
    case ActionType.PTE_SET_LAST_PROCESSED_ID:
      return {...state, lastProcessedId: action.lastProcessedId};
    case ActionType.PTE_SET_COL_PITCH_ASSAY_SAMPLE:
      return {...state, colPitchAssaySample: action.colPitchAssaySample};
    case ActionType.PTE_SET_TROUGH_DEPTH:
      return {...state, troughDepth: action.troughDepth};
    case ActionType.RESTORE_PLATE_TYPE_EDITOR_STATE:
      return action.state;
    case ActionType.RESET_PLATE_TYPE_EDITOR_STATE:
      return {...initialState};
    case ActionType.SET_PTE_EDIT_MODE:
      return {...state, editMode: action.editMode};
    case ActionType.SET_PTE_EJECT_TRAY:
      return {...state, isEjectedTray: action.isEjectedTray};
    default:
      return state;
  }
}
